import React, { Component } from "react";
import { array, shape, bool, string, func } from "prop-types";
import flowRight from "lodash/flowRight";

import formField from "pages/forms/_components/_fields/_commons/formField";
import FormattedAmount from "pages/_components/FormattedAmount";
import withFocus from "pages/_components/withFocus";
import ProductTag from "pages/_components/ProductTag";
import Select from "pages/forms/_components/_fields/Select";

class Productselector extends Component {
    static propTypes = {
        data: shape({ options: array }).isRequired,
        editing: bool.isRequired,
        value: string.isRequired,
        toggleIsFocused: func.isRequired,
        onBlur: func,
        mode: string.isRequired,
        setValue: func.isRequired,
        idField: string.isRequired,
        placeholder: string,
        disabled: bool,
        onChange: func,
        isLoading: bool,
        menuPlacement: string,
    };

    static defaultProps = {
        placeholder: null,
        disabled: false,
        onBlur: () => {},
        onChange: null,
        isLoading: false,
        menuPlacement: "auto",
    };

    handleChange = ({ id }) => {
        const { setValue, onChange } = this.props;
        if (onChange) {
            onChange(id);
        }
        if (id) {
            setValue(id);
        }
    };

    handleBlur = (e) => {
        const { onBlur, toggleIsFocused } = this.props;

        toggleIsFocused();
        onBlur();
    };

    buildProductOptions = (originalOptions) =>
        originalOptions.map((elem) => {
            if (elem.balance) {
                return {
                    id: elem.id,
                    label: (
                        <>
                            <span>{elem.label}</span>
                            <FormattedAmount quantity={elem.balance.quantity} currency={elem.balance.currency} />
                        </>
                    ),
                };
            }
            return {
                id: elem.id,
                label: elem.label,
            };
        });

    render() {
        const {
            editing,
            value,
            toggleIsFocused,
            data: { options },
            idField,
            placeholder,
            disabled,
            isLoading,
            menuPlacement,
        } = this.props;

        if (editing) {
            const newOptions = this.buildProductOptions(options);

            return (
                <div className="input-group-standard">
                    <div className="w-full">
                        <Select
                            id={idField}
                            value={value}
                            clearable={false}
                            searchable={false}
                            onChange={this.handleChange}
                            valueKey="id"
                            labelKey="label"
                            options={newOptions}
                            onFocus={toggleIsFocused}
                            onBlur={this.handleBlur}
                            className="flex-container slideFromBottom"
                            optionClassName="needsclick"
                            placeholder={placeholder || undefined}
                            disabled={disabled}
                            isLoading={isLoading}
                            menuPlacement={menuPlacement}
                        />
                    </div>
                </div>
            );
        }
        const { label } = options.find(({ id }) => id === value) || {};

        return (
            <>
                <ProductTag alias={label} />
            </>
        );
    }
}

export default flowRight(withFocus, formField())(Productselector);
